import "./Footer.scss";
// import Logo from "../../../assets/logo-atlyon.png";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer__container">
                <div className="footer__content">
                    <div className="footer__logo">
                        <span className="footer__logo__text">
                            Nube de puntos
                        </span>
                        {/* <img src={Logo} alt="Atlyon Logo" /> */}
                    </div>

                    <div className="footer__info">
                        <p className="footer__text">
                            Producto desarrollado por{" "}
                            <span className="footer__highlight">
                                Grupo Atlante
                            </span>
                        </p>
                        <p className="footer__copyright">
                            © {currentYear} Grupo Atlante. Todos los derechos
                            reservados.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
